<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Data Discount</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formDiscountActive=!formDiscountActive">Tambah Discount Baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formDiscountActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">Form Discount Baru</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Nama Discount <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newDiscount.discount"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Tipe <span style="color:red;">*</span></label>
								<smart-select name="discount_type" :options="discountTypeOptions"
								              v-on:update="updateNewDiscount"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Total <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded" v-model="newDiscount.price"/>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newDiscountSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Discount Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewDiscount">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Discount Baru.</p>
										</div>
										<div v-for="err in errorDiscountList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="savingNewDiscount">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button" v-on:click="saveNewDiscount">
									Submit
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :datas="discounts" :structure="discountTableStructure"
					           :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-seeker seeker-url="/api/master/seeker/discount"
					           @refetch="(row)=>{rowLimit=row;getDiscounts()}"
					           @searching="(val)=>!val.status?getDiscounts():discounts=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Nama diskon:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.discount }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Tipe:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												translateDiscountType(obj.discount_type)
											}}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Total:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.price | numeral("0,0") }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-edit-airtimeprice class="btn btn-info mr-2"
											          v-on:click="selectedIdforEdit=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</b-button>

										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.discount }}</td>
							<td v-if="!isMobile">{{ translateDiscountType(obj.discount_type) }}</td>
							<td v-if="!isMobile">
								<span v-if="obj.discount_type == 'percent'">{{ obj.price + "%" }}</span>
								<span v-else>{{ obj.price | numeral("0,0") }}</span>
							</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-edit-airtimeprice class="btn btn-info mr-2"
								          v-on:click="selectedIdforEdit=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>
				<b-modal id="modal-edit-airtimeprice" title="Edit data" no-close-on-backdrop size="lg"
				         @hide="editModalClose">
					<div class="row" v-if="discounts[selectedIdforEdit]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Airtime</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="discounts[selectedIdforEdit].discount"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Total</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="discounts[selectedIdforEdit].price"/>
						</div>

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Discount.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Discount.</p>
										</div>
										<div v-for="err in errorDiscountList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button" v-on:click="updateDiscount">
									Simpan
								</button>
								<b-button class="btn btn-secondary mr-2"
								          @click="$bvModal.hide('modal-edit-airtimeprice')">Tutup
								</b-button>
							</div>
						</div>
					</template>
				</b-modal>

				<modal-delete url="/api/master/discount/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Nama Discount: {{ itemToDelete.discount }}</li>
						<li>Total: Rp.{{ itemToDelete.price | numeral("0,0") }}</li>
					</ul>
				</modal-delete>

				<!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-po" title="Konfirmasi hapus data" scrollable no-close-on-backdrop @hide="deleteModalClose">
					<b-container fluid v-if="!loadData">
						<b-row class="pt-1">
						<b-col cols="12" class="my-3">
							<h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
							<ul v-if="discounts.length>0">
								<li>Discount: {{discounts[selectedToDelete].discount}}</li>
								<li>Total: {{discounts[selectedToDelete].price}}</li>
							</ul>
						</b-col>
						<b-col cols="12" class="my-3 text-right"  v-if="deleteState">
							<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3"  v-if="deleted">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil menghapus data discount.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3"  v-if="deleteFail">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal menghapus data discount.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
						<hr>
						<button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button>
						<b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-delete-po'):''">Tutup</b-button>
						</div>
					</template>
				</b-modal> -->

			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			//step 1 edit
			dataEdit: null,
			itemToDelete: {},
			deleteId: 0,
			discounts: [],
			searchValue: "",
			loadData: true,
			savingNewDiscount: false,
			updating: false,
			updateSaved: false,
			deleted: false,
			deleteFail: false,
			deleteState: false,
			selectedToDelete: 0,
			errorNewDiscount: false,
			errorUpdate: false,
			errorDiscountList: [],
			newDiscountSaved: false,
			selectedIdforEdit: 0,
			selectedTab: 0,
			newDiscount: {
				discount: "",
				discount_type: "percent",
				price: ""

			},
			formDiscountActive: false,
			discountTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Nama Discount", key: null},
				{label: "Tipe", key: null},
				{label: "Total", key: null},
				{label: "Tindakan", key: null}
			],
			discountTypeOptions: [
				{label: "Persen", value: "percent"},
				{label: "Nominal", value: "nominal"}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("user page");
		this.getDiscounts();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/discount?limit=" + this.rowLimit + "&page=" + myParams;
			this.getDiscounts(newUrl);
		},
		translateDiscountType(discount_type) {
			var label = "";
			switch (discount_type) {
				case "percent":
					label = "Persen";
					break;
				case "nominal":
					label = "Nominal";
					break;
			}
			return label;
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getDiscounts();
			}
		},
		getDiscounts(url = (this.$baseUrl + "/api/master/discount?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.discounts = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		updateDiscount() {
			this.updating = true;
			this.errorUpdate = false;
			axios.put(
				this.$baseUrl + "/api/master/discount/" + this.discounts[this.selectedIdforEdit].id,
				this.discounts[this.selectedIdforEdit],
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					//step 4 edit
					this.dataEdit = this.discounts[this.selectedIdforEdit];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-airtimeprice");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},
		// saveNewPurchaseOrder(){
		//     this.savingNewDiscount=true
		//     this.errorNewDiscount=false
		//     console.log(this.newPurchaseOrder)
		//     if(this.newPurchaseOrder.no_po!='' && this.newPurchaseOrder.vendor_id!='' && this.newPurchaseOrder.date_po && this.newPurchaseOrder.ppn){
		//         axios.post(this.$baseUrl+'/api/pemesanan/purchaseorder',
		//         {
		//             no_po:this.newPurchaseOrder.no_po,
		//             vendor_id:this.newPurchaseOrder.vendor_id,
		//             date_po:this.newPurchaseOrder.date_po,
		//             ppn:this.newPurchaseOrder.ppn
		//         },
		//         {
		//             'headers':
		//             {
		//                 'Authorization':'Bearer '+localStorage.getItem('accessToken')
		//             }
		//         }).then((result)=>{
		//             //console.log(result)
		//             if(result.data.create){
		//                 this.getDiscounts();
		//             }
		//             this.newDiscount.discount='',
		//             this.newDiscount.price='',
		//             this.savingNewDiscount=false
		//             this.newDiscountSaved=true

		//             setTimeout(() => {
		//                 this.newDiscountSaved=false
		//                 this.formDiscountActive=false
		//             }, 1500);

		//         }).catch((err)=>{
		//check if token fail
		//   if(err.response && err.response.status==401){
		//     localStorage.removeItem('accessToken')
		//   this.$router.push('/login')
		//   }
		//             console.log(err.response)
		//             this.errorDiscountList=[]
		//             this.errorDiscountList=Object.values(err.response.data.errors)
		//             console.log(this.errorDiscountList)
		//             this.errorNewDiscount=true
		//             this.savingNewDiscount=false
		//         })
		//     }
		// },
		deleteItem(index) {
			console.log("button delete untuk user id: " + index);
		},
		// updateUserRoleValue(newValue){
		//     this.newPurchaseOrder.role=newValue
		// },
		// setNewClientId(newId){
		//     this.newPurchaseOrder.clientId = newId;
		//     console.log(this.newPurchaseOrder.clientId)
		// },
		// updateNewHardwareItemType(value){
		//     this.newPurchaseOrder.itemType=value;
		// },
		// smartSearchUpdated(data,index){
		//     this.newPurchaseOrder.hardware.id[index]=data.id
		//     console.log(this.newPurchaseOrder.hardware.id[index])
		// },
		// smartSearchUpdatedVendor(data,index){
		//     this.newPurchaseOrder.vendor_id[index]=data.id
		//     console.log(this.newPurchaseOrder.vendor_id[index])
		// },
		saveNewDiscount() {
			//if(this.newPurchaseOrder.no_po!=''){}
			// console.log(this.newPurchaseOrderSaved)
			// return;
			this.savingNewDiscount = true;
			this.errorNewDiscount = false;
			console.log(this.errorDiscountList);
			axios.post(this.$baseUrl + "/api/master/discount", {
				           "discount": this.newDiscount.discount,
				           "discount_type": this.newDiscount.discount_type,
				           "price": this.newDiscount.price
			           },
			           {
				           "headers":
					           {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
			           }
			).then((result) => {
				console.log(result);
				this.savingNewDiscount = false;
				this.newDiscountSaved = true;
				this.getDiscounts();
				setTimeout(() => {
					this.formDiscountActive = false;
					this.newDiscountSaved = false;
				}, 1000);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.errorDiscountList = [];
				this.errorDiscountList = Object.values(err.response.data.errors);
				console.log(this.errorDiscountList);
				this.savingNewDiscount = false;
				this.errorNewDiscount = true;
			});
		},
		deleteModalClose() {
			console.log("test");
		},
		deleteData() {
			this.deleteState = true;
			axios.delete(this.$baseUrl + "/api/master/discount/" + this.discounts[this.selectedToDelete].id, {
				headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
			})
			     .then((result) => {
				     if (result.status == 200) {
					     this.discounts.splice(this.selectedToDelete, 1);
					     this.deleted = true;
					     setTimeout(() => {
						     this.deleted = false;
					     }, 1500);

				     } else {
					     this.deleteFail = true;
				     }
				     this.deleteState = false;
			     }).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.deleteState = false;
				this.deleteFail = true;
			});
		},
		deleteModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-po");
			}
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.discounts, this.selectedIdforEdit, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updating) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-airtimeprice");
			}
		},
		updateNewDiscount(data) {
			this.newDiscount.discount_type = data;
		}

	}
};
</script>
<style scoped>
.dropdown-menu {
	display: none;
}

.btn {
	padding: 2px 6px;
}
</style>
